import React from 'react';

const NotFoundMessage = (props) => (
  <div className="not-found">
    <p>{props.children}</p>
  </div>
);

export default NotFoundMessage;
